import React from "react";
import i18next from "i18next";
import { useTranslation } from "react-i18next";

const Layout = (prop) => {
  const { t } = useTranslation();

  const getPrivacyNoticeUrl = () => {
    switch (i18next.language) {
      case "fr":
        return process.env.REACT_APP_PRIVACY_NOTICE_FR;
      case "it":
        return process.env.REACT_APP_PRIVACY_NOTICE_IT;
      default:
        return process.env.REACT_APP_PRIVACY_NOTICE;
    }
  };

  const currentPrivacyNoticeUrl = getPrivacyNoticeUrl();

  return (
    <div className="az-container">
      <header>
        <div className="az-header-container d-flex ">
          <img
            rel="preload"
            src={process.env.PUBLIC_URL + "images/az-trade-logo.svg"}
            alt="Allianz Trade"
            className="az-trade-logo"
          />
        </div>
      </header>

      <main role="main" className="az-main-content">
        <div className="justify-content-center d-flex pt-40">
          <img
            rel="preload"
            src={process.env.PUBLIC_URL + "images/az-pay-logo.svg"}
            alt="Allianz trade"
            className="az-pay-logo"
          />
        </div>
        <div className="pt-20 az-content-wrapper">{prop.children}</div>
      </main>

      <footer className="d-flex az-footer-container">
        <span>
          <a className="az-footer-privacy" href={currentPrivacyNoticeUrl}>
            {t("footer.privacy")}
          </a>{" "}
          • {t("footer.label")}
        </span>
      </footer>
    </div>
  );
};

export default Layout;
